import React from 'react';
import {
	Button,
	MenuItem,
	Grow,
	Icon
} from '@material-ui/core';
import {
	ExpandLess,
	ExpandMore
} from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import HoverMenu from 'material-ui-popup-state/HoverMenu';
import {
	usePopupState,
	bindHover,
	bindMenu,
} from 'material-ui-popup-state/hooks';

export default function DropdownMenu(props) {
	const popupState = usePopupState({
		variant: 'popover',
		popupId: 'demoMenu',
	});
	const theme = useTheme();

	return (
		<div>
			<Button style={{ outline: 0 }} {...bindHover(popupState)}>
				{props.item.label}
				{popupState.isOpen ? <ExpandLess /> : <ExpandMore />}
			</Button>
			<HoverMenu
				{...bindMenu(popupState)}
				TransitionComponent={Grow}
				getContentAnchorEl={null}
				disableScrollLock
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
			>
				{props.item.submenu.map((item) => (
					<MenuItem
						key={item.id}
						onClick={() => { popupState.close(); window.location = item.url; }}
						style={{ padding: '10px 20px' }}
					>
						<Icon style={{ marginRight: '10px', color: theme.palette.primary.main, fontSize: '25px' }}>
							{item.icon}
						</Icon>
						{item.label}
					</MenuItem>
				))}
			</HoverMenu>
		</div>
	);
}
